import { AppState, type AppStateData } from '../../core/AppState';

export class PreviewPane {
  private container: HTMLElement;
  private state: AppState;
  private currentBlobUrl: string | null = null;
  private previewArea: HTMLElement;

  constructor(container: HTMLElement, state: AppState) {
    this.container = container;
    this.state = state;
    this.container.style.flex = '1';
    this.container.style.display = 'flex';
    this.container.style.flexDirection = 'column';
    this.container.style.overflow = 'hidden';

    // Preview Area
    this.previewArea = document.createElement('div');
    this.previewArea.className = 'preview-pane';
    this.previewArea.style.flex = '1';
    this.previewArea.style.backgroundColor = '#000';
    this.previewArea.style.position = 'relative';
    this.previewArea.style.display = 'flex';
    this.previewArea.style.alignItems = 'center';
    this.previewArea.style.justifyContent = 'center';
    this.previewArea.style.overflow = 'hidden';
    this.previewArea.style.backgroundImage = 'linear-gradient(45deg, #151515 25%, transparent 25%), linear-gradient(-45deg, #151515 25%, transparent 25%), linear-gradient(45deg, transparent 75%, #151515 75%), linear-gradient(-45deg, transparent 75%, #151515 75%)';
    this.previewArea.style.backgroundSize = '20px 20px';

    this.previewArea.innerHTML = `
        <img id="previewImg" src="" style="max-width:95%; max-height:95%; box-shadow:0 0 30px rgba(0,0,0,0.5); object-fit:contain; display:none;">
        <div id="emptyState" style="color:#666;">No image loaded</div>
    `;
    this.container.appendChild(this.previewArea);

    // Subscribe
    this.state.subscribe((data) => this.update(data));
  }

  private update(data: AppStateData) {
    const img = this.previewArea.querySelector('#previewImg') as HTMLImageElement;
    const empty = this.previewArea.querySelector('#emptyState') as HTMLElement;

    if (data.buffer) {
      empty.style.display = 'none';
      img.style.display = 'block';

      if (this.currentBlobUrl) URL.revokeObjectURL(this.currentBlobUrl);

      const mimeType = this.getMimeType(data.filename);
      const blob = new Blob([data.buffer as any], { type: mimeType });
      this.currentBlobUrl = URL.createObjectURL(blob);
      img.src = this.currentBlobUrl;
    } else {
      empty.style.display = 'block';
      img.style.display = 'none';
      img.src = '';
    }
  }

  private getMimeType(filename: string | null): string {
    if (filename && filename.toLowerCase().endsWith('.webp')) {
      return 'image/webp';
    }
    if (filename && filename.toLowerCase().endsWith('.png')) {
      return 'image/png';
    }
    if (filename && filename.toLowerCase().endsWith('.gif')) {
      return 'image/gif';
    }
    return 'image/jpeg';
  }
}
